import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Feed, Icon } from 'semantic-ui-react';

import InfluencerAddedEvent from './card-events/influencer-added-event';
import CampaignCreatedEvent from './card-events/campaign-created-event';
import UserAddedEvent from './card-events/user-added-event';
import ShortlistCreatedEvent from './card-events/shortlist-created-event';
import ACRCampaignScannedEvent from './card-events/acr-campaign-scanned-event';

import {
  EVENT_TYPES,
} from './../../hocs/data/with-dyzio-events-data';

const feedItemStyles = {
  borderBottom: '1px dashed #eee',
};

const feedSummaryStyle = {
  color: 'rgba(0,0,0, 0.7)',
};

const iconStyle = {
  marginTop: 5,
};

const Event = ({ icon, color, createdDate, children }) => (
  <Feed.Event style={feedItemStyles}>
    <Feed.Label>
      <Icon style={iconStyle} name={icon} color={color} />
    </Feed.Label>
    <Feed.Content>
      <Feed.Date>{createdDate && moment(createdDate).fromNow()}</Feed.Date>
      <Feed.Summary style={feedSummaryStyle}>
        { children }
      </Feed.Summary>
    </Feed.Content>
  </Feed.Event>
);

Event.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  createdDate: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
};

const AutoCampaignScanEvent = ({ messageData: { assetCount, hashtags }, createdDate }) => {
  const HASHTAG_STYLE = { fontStyle: 'italic', color: 'black' };
  return (
    <Event icon="search" color={assetCount ? 'pink' : 'green'} createdDate={createdDate}>
      <p>
        Scanned for posts containing
        <span style={HASHTAG_STYLE}>
          {` ${hashtags}`}
        </span>
        .
      </p>
      <p>
        Found {assetCount} posts.
      </p>
    </Event>
  );
};

const EventFeedItem = ({ message, eventName, ...rest }) => {
  switch (eventName) {
  case EVENT_TYPES.INFLUENCER_CREATED:
    return <InfluencerAddedEvent {...rest} />;
  case EVENT_TYPES.CAMPAIGN_CREATED:
    return <CampaignCreatedEvent {...rest} />;
  case EVENT_TYPES.USER_CREATED:
    return <UserAddedEvent {...rest} />;
  case EVENT_TYPES.SHORTLIST_CREATED:
    return <ShortlistCreatedEvent {...rest} />;
  case EVENT_TYPES.CAMPAIGN_SCANNED:
    return <ACRCampaignScannedEvent {...rest} />;
  default:
  }


  if (message.match(/Campaign was created/)) {
    return <Event color="pink" icon="sun" {...rest}>Campaign was created</Event>;
  }
  if (message.match(/Automated Campaign scan executed/)) {
    return <AutoCampaignScanEvent {...rest} />;
  }
  if (message.match('')) { return null; }
};

EventFeedItem.propTypes = {
  messageData: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
  eventName: PropTypes.string.isRequired,
  createdDate: PropTypes.string.isRequired,
};

export default EventFeedItem;



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/event-card-item.js
 **/